export { default } from './NFe'
export * as S from './NFe.styles'
